import { darken } from "@material-ui/core/styles/colorManipulator";
import styled from "styled-components";

export default styled("button")`
    align-items: center;
    background: ${(props) => props.theme.palette.common.white};
    border: none;
    border-radius: 1px;
    box-sizing: border-box;
    color: ${(props) => props.theme.palette.common.black};
    cursor: pointer;
    display: flex;
    font-size: 16px;
    font-weight: bold;
    justify-content: center;
    letter-spacing: 1.5px;
    line-height: 1.5em;
    padding: 0.75em;
    position: relative;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    width: 100%;

    :hover {
        background: ${(props) => darken(props.theme.palette.common.white, 0.08)};
        transition: all 0.3s ease;
    }

    :active {
        background: ${(props) => darken(props.theme.palette.common.white, 0.25)};
    }

    :disabled {
        background: ${(props) => props.theme.palette.grey[20]};
        cursor: default;
    }

    ${(props) => props.theme.breakpoints.up("desktop")} {
        padding: 0.75em 2em;
    }
`;
